import React from 'react';
import { Download } from 'lucide-react';

interface ExportButtonProps {
  onExport: () => void;
  label?: string;
  disabled?: boolean;
  loading?: boolean;
}

export const ExportButton: React.FC<ExportButtonProps> = ({
  onExport,
  label = 'Export CSV',
  disabled = false,
  loading = false,
}) => {
  return (
    <button
      onClick={onExport}
      disabled={disabled || loading}
      className="inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg shadow-sm text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
    >
      <Download className={`h-4 w-4 mr-2 ${loading ? 'animate-bounce' : ''}`} />
      {loading ? 'Exporting...' : label}
    </button>
  );
};
